import { Result } from 'domain/types';
import ReadWidgetsClient from 'use-case/widgets/read/readWidgetsClient';
import ReadWidgetsCriteria from 'use-case/widgets/read/readWidgetsCriteria';
import Widget from 'domain/entity/widget';

export type ReadWidgetsResult = Result<Widget[]>;
export type ReadWidgets = (criteria: ReadWidgetsCriteria) => Promise<ReadWidgetsResult>;

export default (readWidgetClient: ReadWidgetsClient): ReadWidgets => (criteria: ReadWidgetsCriteria): Promise<ReadWidgetsResult> =>
    readWidgetClient(criteria);
